import * as yup from "yup";

export const updateMobileCombustionValidation = yup.object({
  facility: yup.string().required("Facility is required"),
  month: yup.string().required("Month is required"),
  year: yup.string().required("Year is required"),
  activityType: yup.string().required("Activity Type is required"),
  fuelSource: yup.string().required("Fuel Source is required"),
  fuelUnit: yup.string().required("Fuel unit is required"),
  amountOfFuel: yup
    .number()
    .typeError("Amount of fuel must be a valid number")
    .required("Amount of fuel is required")
    .strict(true),
});
